import axios, { AxiosRequestConfig } from 'axios';
import { JsonObject } from '../helpers';
import Environment from '../environment';
import { AuthProvider } from './auth.service';
import {
  ApiResponse,
  handleResponse,
  handleUpdateErrorResponse,
  handleUpdateResponse,
  UpdateErrorHandler,
  UpdateResponse,
} from '.';

const axiosClient = axios.create({
  baseURL: Environment.SP_API_URL,
  timeout: 10000,
  withCredentials: true,
  responseType: 'json',
  headers: {
    'X-Requested-By': 'surepath',
  },
});

// @todo doesn't the status call need the cookie?
axiosClient.interceptors.request.use((config) => {
  if (AuthProvider.token) {
    config.headers['Surepath-Authorization'] = `Bearer ${AuthProvider.token}`;
  }
  return config;
});

export const post = async (
  path: string,
  data: JsonObject | FormData,
  params?: JsonObject
): Promise<ApiResponse> => {
  return axiosClient
    .post(path, data, {
      headers: {
        'Content-Type': 'application/json',
      },
      ...(params || {}),
    })
    .then(handleResponse);
};

export const get = async (path: string, params?: JsonObject): Promise<ApiResponse> => {
  return axiosClient.get(path, { params }).then(handleResponse);
};

export const update = async (
  path: string,
  data: JsonObject | FormData,
  opts: AxiosRequestConfig = {},
  onError: UpdateErrorHandler = handleUpdateErrorResponse
): Promise<UpdateResponse> => {
  return axiosClient
    .put(path, data, {
      headers: {
        'Content-Type': 'application/json',
      },
      ...opts,
    })
    .then(handleUpdateResponse)
    .catch(onError);
};
